import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-timezone'

import { Modal, Button } from 'components'
import { FaTimes } from 'react-icons/fa'
import BannerImg from 'resources/feedback-banner.png'

import * as actionCreators from 'store/actions';
import * as api from 'api'

const Container = styled.div`
    box-shadow: var(--box-shadow);
    background-color: var(--primary-color);
    border: 1px solid var(--secondary-color);
    border-radius: 5px;
    padding: 1rem 0;
    max-height: 60vh;
    width: 80vw;
    max-width: 30rem;

    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-row-gap: 0.5rem;
`

const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 1rem;
`

const Wrapper = styled.div`
    padding: 0 0.8rem;
    margin: 0 0.2rem;
    display: grid;
    grid-template-rows: auto calc(60% - 1rem);
    grid-row-gap: 1rem;
    height: inherit;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 0.3rem !important;
    }
    &::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0) !important;
        /* background-color: transparent !important; */
        background-color: var(--primary-accent-color) !important;
    }
`

const Footer = styled.div`
    padding: 0 1rem;
    display: flex;
    justify-content: flex-end;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
`

const Title = styled.div`
    font-weight: bold;
    font-size: 1.2rem;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
`

const Image = styled.img`
    width: 100%; 
    height:100%;
    /* object-fit: contain; */
    border-radius: 5px;
    border: 1px solid var(--secondary-color);
`

const Section = styled.div`
    margin-bottom: ${props => props.marginBottom || '1rem'};
`

const SectionHeader = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 0.5rem;
    align-items: center;
`

const SectionTitle = styled.div`
    font-weight: bold;
    text-transform: uppercase;
    color: var(--focus-color);
    font-size: 0.8rem;
`

const SectionDivider = styled.div`
    border-top: 1px solid var(--focus-color);
    height: 1px;
`

const SectionContent = styled.div`

`

const List = styled.ul`
    /* list-style: none; */
    padding: 0 1rem;
    margin: 0.25rem;
    font-size: 0.9rem;
`;

const ListItem = styled.li`
    padding: 0.25rem 0;
`;

const UpdatesModal = props => {
    const {} = props;
    const dispatch = useDispatch()
    const user = useSelector(state => state.auth.user)
    const [update, setUpdate] = React.useState(null)

    React.useEffect(() => {
        api.getLatestUpdate()
        .then(res => setUpdate(res.data['update']))
        .catch(err => console.log(err))
    }, [])

    const onClose = () => {
        let updatedUser = {...user}
        updatedUser['show_updatesModal'] = false
        dispatch(actionCreators.updateUser(updatedUser))
        dispatch(actionCreators.setModal(null,null))
    }
    console.log(update)
    const date = update && moment(update['date']).format('D MMM YYYY')
    const sections = update ? update.sections : []
    // const date = '25 Feb 2022'
    // const sections = [
    //     {
    //         title: 'New features',
    //         content: [
    //             'lorep ipsum',
    //             'second line',
    //             'blah blah'
    //         ]
    //     },
    //     {
    //         title: 'New features',
    //         content: [
    //             'lorep ipsum',
    //             'second line',
    //             'blah blah'
    //         ]
    //     },
    //     {
    //         title: 'New features',
    //         content: [
    //             'lorep ipsum',
    //             'second line',
    //             'blah blah'
    //         ]
    //     },
    // ]

    return (
        <Modal onClose={onClose}>
            <Container>
                <Header>
                    <Column>
                        <Title>What's new ({update && update['version']})</Title>
                        <Subtitle>{date}</Subtitle>
                    </Column>

                    <Button icon={<FaTimes/>} styles={{ margin: 0, padding: '0.5rem', boxShadowColor: 'transparent', backgroundColor: 'var(--primary-color)' }} onSelect={onClose}/>
                </Header>

                <Wrapper>
                    <Image src={update && update['image']}/>

                    <Content>
                        {sections.map((section,index) => (
                            <Section marginBottom={index === sections.length - 1 && '0'}>
                                <SectionHeader>
                                    <SectionTitle>{section['title']}</SectionTitle>
                                    <SectionDivider/>
                                </SectionHeader>
                                <List>
                                    {section['content'].map(block => (<ListItem>{block}</ListItem>))}
                                </List>
                            </Section>
                        ))}
                    </Content>
                </Wrapper>

                <Footer>
                    <Button text='Dismiss' onSelect={onClose}
                        styles={{ margin: 0, backgroundColor: 'var(--focus-color)' }}/>
                </Footer>
            </Container>
        </Modal>
    )
}

export default UpdatesModal